module.exports = __webpack_public_path__ + "static/scale-model-of-deweese-ridgecrest-civic-association-in-dayton-ohio-6fe60dc0c49a2749a8258e58a6886541.png";